/*
 * Linguetta «10% di sconto» di Shopify Forms sul bordo sinistro, così non copre la
 * linguetta delle recensioni Judge.me a destra.
 * La posizione si sceglie nell'app Forms, ma vale per tutti i temi (anche il live). Il
 * modulo vive in uno shadow DOM aperto dove il CSS del tema non arriva: qui si aggiunge
 * una regola dentro lo shadow root e la si rimette se l'app ridisegna il contenuto.
 * Vale solo per la linguetta chiusa (data-current-step="tease"): il modulo aperto resta
 * com'è nell'app.
 */
(() => {
  const LINGUETTA = '#app-embed[data-position="right-middle-rotated"][data-current-step="tease"]';
  const REGOLE = `
    ${LINGUETTA} {
      left: 0 !important;
      right: auto !important;
      justify-content: flex-start !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    ${LINGUETTA} > div {
      transform: translateX(-50%) !important;
      transform-origin: left top !important;
    }
    /* Più sottile (40px su mobile, come la linguetta Judge.me): copre meno pagina. */
    ${LINGUETTA} > div > button {
      margin: 0 !important;
      padding-top: 10px !important;
      padding-bottom: 10px !important;
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
    }
  `;

  const aggiungi = (radice) => {
    if (radice.querySelector('style[data-gm-app]')) return;
    const stile = document.createElement('style');
    stile.dataset.gmApp = '';
    stile.textContent = REGOLE;
    radice.append(stile);
  };

  const aggancia = (host) => {
    const radice = host.shadowRoot;
    if (!radice || host.dataset.gmApp) return Boolean(radice);
    host.dataset.gmApp = '';
    aggiungi(radice);
    new MutationObserver(() => aggiungi(radice)).observe(radice, { childList: true });
    return true;
  };

  // L'app crea <shopify-forms-embed> e il suo shadow root dopo il caricamento: si
  // controlla spesso nei primi 5 secondi (la linguetta non deve comparire a destra),
  // poi ogni mezzo secondo fino a 30 secondi, poi si smette.
  let attesa = 0;
  const cerca = () => {
    const host = document.querySelector('shopify-forms-embed');
    if ((host && aggancia(host)) || attesa > 30000) return;
    const passo = attesa < 5000 ? 100 : 500;
    attesa += passo;
    setTimeout(cerca, passo);
  };
  cerca();
})();
